import { useEffect, useState } from "react";
import { getConcelhos, getDistritos, getFreguesias } from "../../api/reference";
import { useErrorHandler } from "../Error/useErrorHandler";

export function useLocationData(
  distritoId?: number | null,
  concelhoId?: number | null
) {
  const handleError = useErrorHandler();
  const [distritos, setDistritos] = useState<any[]>([])
  const [concelhos, setConcelhos] = useState<any[]>([])
  const [freguesias, setFreguesias] = useState<any[]>([])

  useEffect(() => {
    async function fetchData() {
      try {
        const distritosData = await getDistritos();
        setDistritos(distritosData);

        if (distritoId) {
          const concelhosData = await getConcelhos(distritoId);
          setConcelhos(concelhosData);
        }

        if (distritoId && concelhoId) {
          const freguesiasData = await getFreguesias(distritoId, concelhoId);
          setFreguesias(freguesiasData);
        }

      } catch (error) {
        handleError(error);
      }
    }

    fetchData();
  }, [distritoId, concelhoId]);

  return { distritos, concelhos, freguesias };
}